import React from "react";
import PropTypes from "prop-types";

const Span = ({ attrs, children }) => <span {...attrs}>{children}</span>;

Span.propTypes = {
    attrs: PropTypes.object,
    children: PropTypes.node,
};

Span.defaultProps = {
    attrs: undefined,
    children: undefined,
};

export default Span;
